export { MapPin as default } from './MapPin';
